import { Routes, Route } from 'react-router-dom';
import Login from '../components/Login'
import { SinglePageLayout } from '../common/layout/singlepage';
import { Leads } from '../components/Leads';
import { Users } from '../components/Users';
import { UserDetails } from '../components/UserDetails';
import { useUserStore } from '../stores/user-store';
import UnAuthorizeComponent from '../components/UnAuthorizeComp/templates';
import { LeadDetails } from '../components/LeadDetails';

import Password from '../components/Password';

import { Profiles } from '../components/Profile';
import { ProfileDetails } from '../components/ProfileDetails';
import { Bookings } from '../components/Bookings';
import { BookingDetails } from '../components/BookingDetails';
import { DashboardCall } from '../components/Dashboard-call';
import { AssignedLeads } from '../components/AssignedLeads';
import { Dashboard } from '../components/Dashboard';
import { DashboardLeads } from '../components/Dashboard-leads';
//import { DashboardPatch } from '../components/Dashboard-patch';
import { DashboardDateWise } from '../components/Dashboard-DateWise';
import { Institutes } from '../components/Institutes';
import { InstituteDetails } from '../components/InstituteDetails';
import { InstituteCallLogs } from '../components/InstituteCallLogs';
import { Students } from '../components/Students';
import { StudentDetails } from '../components/StudentDetails';
import { StudentsCount } from '../components/StudentsCount';
import { Agreements } from '../components/Agreements';
import { AgreementDetails } from '../components/AgreementDetails';
import { Enquiry } from '../components/Enquiry';

const Root = () => {
    const userData = useUserStore;
    return (

        <Routes>
            {(userData.getState().allowedRoutes).includes('Users') ?
                <Route path='/users' element={<SinglePageLayout component={Users} />} />
                :
                <Route path='/users' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Profiles') ?
                <Route path='/profiles' element={<SinglePageLayout component={Profiles} />} />
                :
                <Route path='/profiles' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Profiles') ?
                <Route path='/profile/:profile_id?' element={<SinglePageLayout component={ProfileDetails} />} />
                :
                <Route path='/profile/:profile_id?' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }


            {(userData.getState().allowedRoutes).includes('Users') ?
                <Route path='/user/:user_id?' element={<SinglePageLayout component={UserDetails} />}>
                </Route>
                : <Route path='/user/:user_id?' element={<SinglePageLayout component={UnAuthorizeComponent} />} />}

            {(userData.getState().allowedRoutes).includes('Leads') ?
                <Route path='/leads' element={<SinglePageLayout component={Leads} />} />
                :
                <Route path='/leads' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Institutes') ?
                <Route path='/institutes' element={<SinglePageLayout component={Institutes} />} />
                :
                <Route path='/institutes' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Enquiry') ?
                <Route path='/enquiries' element={<SinglePageLayout component={Enquiry} />} />
                :
                <Route path='/enquiries' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Students') ?
                <Route path='/students' element={<SinglePageLayout component={Students} />} />
                :
                <Route path='/students' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Agreements') ?
                <Route path='/agreements' element={<SinglePageLayout component={Agreements} />} />
                :
                <Route path='/agreements' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Agreements') ?
                <Route path='/agreement/:agreement_id?' element={<SinglePageLayout component={AgreementDetails} />} />
                :
                <Route path='/agreement/:agreement_id?' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Assigned') ?
                <Route path='/assigned-leads' element={<SinglePageLayout component={AssignedLeads} />} />
                :
                <Route path='/assigned-leads' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }

            <Route path='/lead/:lead_id?' element={<SinglePageLayout component={LeadDetails} />} />

            {(userData.getState().allowedRoutes).includes('Students') ?
                <Route path='/institute/:institute_id?' element={<SinglePageLayout component={InstituteDetails} />} />
                :
                <Route path='/students' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Institutes') ?
                <Route path='/student/:student_id?' element={<SinglePageLayout component={StudentDetails} />} />
                :
                <Route path='/students' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }



            {(userData.getState().allowedRoutes).includes('Dashboard') ?
                <Route path='/dashboards' element={<SinglePageLayout component={Dashboard} />} />
                :
                <Route path='/dashboards' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Dashboard') ?
                <Route path='/dashboard/calls' element={<SinglePageLayout component={DashboardCall} />} />
                :
                <Route path='/dashboard/calls' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
           
            {(userData.getState().allowedRoutes).includes('Dashboard') ?
                <Route path='/dashboard/leads' element={<SinglePageLayout component={DashboardLeads} />} />
                :
                <Route path='/dashboard/leads' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {/* {(userData.getState().allowedRoutes).includes('Dashboard') ?
                <Route path='/dashboard/patch' element={<SinglePageLayout component={DashboardPatch} />} />
                :
                <Route path='/dashboard/patch' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            } */}
            {(userData.getState().allowedRoutes).includes('Dashboard') ?
                <Route path='/dashboard/date-wise' element={<SinglePageLayout component={DashboardDateWise} />} />
                :
                <Route path='/dashboard/date-wise' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Dashboard') ?
                <Route path='/dashboard/institute-call-logs' element={<SinglePageLayout component={InstituteCallLogs} />} />
                :
                <Route path='/dashboard/institute-call-logs' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }
            {(userData.getState().allowedRoutes).includes('Dashboard') ?
                <Route path='/dashboard/student-enrolled' element={<SinglePageLayout component={StudentsCount} />} />
                :
                <Route path='/dashboard/student-enrolled' element={<SinglePageLayout component={UnAuthorizeComponent} />} />
            }


            <Route path='/login' element={<SinglePageLayout component={Login} />}>
            </Route>
            <Route path='/password/:screen?' element={<SinglePageLayout component={Password} />}>
            </Route>
            <Route path='/' element={<SinglePageLayout component={''} />}>
            </Route>
        </Routes>
    );
}

export default Root;